import { render, staticRenderFns } from "./CarbonCreditsMarketWatchStatic.vue?vue&type=template&id=1bb7300a&scoped=true"
import script from "./CarbonCreditsMarketWatchStatic.vue?vue&type=script&lang=js"
export * from "./CarbonCreditsMarketWatchStatic.vue?vue&type=script&lang=js"
import style0 from "./CarbonCreditsMarketWatchStatic.vue?vue&type=style&index=0&id=1bb7300a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb7300a",
  null
  
)

/* custom blocks */
import block0 from "./CarbonCreditsMarketWatchStatic.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports